import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { BaseManufacturingOrder } from '../../../../core/models/base-manufacturing-order';
import { filter, isNotEmpty, sortByProperties } from '../../../../core/utils/collection.utils';

@Component({
  selector: 'app-base-manufacturing-order-filter',
  templateUrl: './base-manufacturing-order-filter.component.html',
  styleUrls: ['./base-manufacturing-order-filter.component.css']
})
export class BaseManufacturingOrderFilterComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  control: FormControl;
  filteredManufacturingOrders: BaseManufacturingOrder[];
  @Input() baseManufacturingOrders: BaseManufacturingOrder[];
  @Input() selectedManufacturingOrder: BaseManufacturingOrder;
  @Input() editing: boolean;
  @Output() selectOrder = new EventEmitter<BaseManufacturingOrder>();
  @Output() cleanProof = new EventEmitter<void>();
  @Output() filtering = new EventEmitter<boolean>();
  private subscription: Subscription;

  constructor(
    private fb: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.control = this.fb.control('');
    this.filteredManufacturingOrders = [];
    this.subscription = this.control.valueChanges
      .subscribe((value) => {
        if (value && value !== '') {
          this.onFilter(value.toLowerCase());
        }
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('selectedManufacturingOrder') || changes.hasOwnProperty('editing')) {
      this.filteredManufacturingOrders = this.selectedManufacturingOrder || this.editing ? [] :
        [];
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.changeDetectorRef.detectChanges();
  }

  onFilter(filterValue: string) {
    this.cleanProof.emit();
    if (filterValue === '' && (this.selectedManufacturingOrder || this.editing)) {
      this.filteredManufacturingOrders = [];
      this.filtering.emit(false);
    } else {
      this.filteredManufacturingOrders = filter((order) => order.filterableData.includes(filterValue),
        this.getNotNCBaseManufacturingOrders(this.baseManufacturingOrders));
      this.filteredManufacturingOrders = sortByProperties(this.filteredManufacturingOrders, ['code', 'projectNumber']);
      this.filtering.emit(true);
    }
  }

  onSelectOrder(order: BaseManufacturingOrder) {
    this.control.setValue('', { emitEvent: false });
    this.selectOrder.emit(order);
  }

  get filteredManufaturingOrderNotEmpty() {
    return isNotEmpty(this.filteredManufacturingOrders);
  }

  private getNotNCBaseManufacturingOrders(baseManufacturingOrders: BaseManufacturingOrder[]) {
    return filter((base: BaseManufacturingOrder) => !!/^\d+$/.test(base.projectNumber), baseManufacturingOrders);
  }

  get orders() {
    return this.filteredManufacturingOrders;
  }

  cleanFilteredManufacturingOrders() {
    this.filteredManufacturingOrders = [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/general/base-manufacturing-order-filter/base-manufacturing-order-filter.component.ts